export const Dropdown = (props: any) => {
  const { dropdownActive, onDropdownClick = () => {} } = props;

  return (
    <div
      className="docu-jmp-btn-ddown"
      onClick={(e) => {
        e.stopPropagation();
        onDropdownClick();
      }}
    >
      <i className={dropdownActive ? "fa fa-angle-up" : "fa fa-angle-down"} />
    </div>
  );
};
